import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Icon from './icon';
import { consistentString } from '../../utils/content-formatting';
import { Wrapper, ShareLink } from './styles';
import { Container } from '../styled/containers';
import { sendEvent } from '../../utils/analytics';
import { useLayout } from '../layout/context';
import { usePageMeta } from '../page';

const ShareBlock = ({ headerText, shareType, greyBackground }) => {
  const { insideContainer } = useLayout();

  const socialUrl = {
    Print: 'printer',
    Email: 'mailto:?&subject=Shelter&body=',
    WhatsApp: 'https://api.whatsapp.com/send?text=',
    Twitter: 'https://x.com/share?url=',
    Facebook: 'https://www.facebook.com/sharer/sharer.php?u=',
  };

  const { url: pageUrl } = usePageMeta();

  const pushAnalyticsEvent = (type) => {
    if (type === 'Print') {
      sendEvent({
        event: 'pageInteraction',
        interactType: 'Printed Article',
        printSource: 'CTA',
      });
    } else if (type === 'Email') {
      sendEvent({
        interactType: 'Emailed Article',
        event: 'pageInteraction',
      });
    } else {
      sendEvent({
        sharedTo: type,
        sharedText: null,
        interactType: 'Social Share',
        event: 'pageInteraction',
      });
    }
  };

  return (
    <Container $padding={!insideContainer}>
      {headerText && <h3>{headerText}</h3>}
      <Wrapper $greyBackground={greyBackground}>
        {shareType &&
          shareType.map((type, i) => (
            <Fragment key={i}>
              {type === 'Print' && (
                <ShareLink
                  as="button"
                  onClick={() => {
                    window.print();
                    pushAnalyticsEvent(type);
                  }}
                  onKeyDown={(event) => {
                    if (event.keycode === 13) {
                      window.print();
                      pushAnalyticsEvent(type);
                    }
                  }}
                  type="button"
                  $bg="secondary-outline"
                >
                  <Icon icon="print" />
                  Print this article
                </ShareLink>
              )}
              {socialUrl[type] && type !== 'Print' && (
                <ShareLink
                  href={
                    type === 'Email'
                      ? `${socialUrl[type]}${pageUrl}`
                      : `${socialUrl[type]}${pageUrl}?utm_source=${type}&utm_medium=social&utm_campaign=social_sharing_icons`
                  }
                  target="_blank"
                  rel="noopener"
                  className="tracking-share"
                  data-tracking={type}
                  onClick={() => {
                    pushAnalyticsEvent(type);
                  }}
                  onKeyDown={(e) => {
                    if (e.keydown === 13) {
                      pushAnalyticsEvent(type);
                    }
                  }}
                  $bg="secondary-outline"
                >
                  <Icon icon={consistentString(type)} />
                  {type}
                </ShareLink>
              )}
            </Fragment>
          ))}
      </Wrapper>
    </Container>
  );
};

ShareBlock.propTypes = {
  headerText: PropTypes.string,
  shareType: PropTypes.arrayOf(
    PropTypes.oneOf(['Print', 'Email', 'WhatsApp', 'Twitter', 'Facebook'])
  ).isRequired,

  greyBackground: PropTypes.bool,
};
export default ShareBlock;

export const ShareBlockAssembly = ({ contentfulData }) => (
  <ShareBlock
    headerText={contentfulData.headerText}
    shareType={contentfulData.shareType}
  />
);

ShareBlockAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
